import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
    const location = useLocation();
    const adminToken = sessionStorage.getItem('adminToken');
    const adminUser = sessionStorage.getItem('adminUser');

    // Check if user is authenticated
    if (!adminToken || !adminUser) {
        // Redirect to login page with return location
        return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
    }

    return children;
}

